import React from 'react';

export const ButtonTextTestId = 'buttontext-input';

type ButtonTextProps = {
  children: string;
  isOtherActionPending: boolean;
};

const ButtonText: React.FC<ButtonTextProps> = ({
  children,
  isOtherActionPending,
}: ButtonTextProps) => {
  return isOtherActionPending ? (
    <div className="three-dots" data-testid={ButtonTextTestId}>
      <span />
      <span />
      <span />
    </div>
  ) : (
    <span data-testid={ButtonTextTestId}>{children}</span>
  );
};

export default ButtonText;
